// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"b51fc714","353":"aa13e0c8"}[chunkId] + ".chunk.css";
};